export default "__VITE_ASSET__BXf6SBqr__"